module.exports = __webpack_public_path__ + "img/personality-analysis-mma.ab641b21.svg";